import { translate } from '../../../../../helpers/locale-helpers';

export const studentDataTranslations = () => ({
    standardText: translate('Student Data Table - Standard'),
    infoProgressText: translate('Student Data Table - Info Progress'),
    allHighestInfoText: translate('Student Data Table - Info All Highest'),
    teacherAssignedInfoText: translate(
        'Student Data Table - Info Teacher Assigned'
    ),
    voluntaryInfoText: translate('Student Data Table - Info Voluntary'),
    infoCompletedTextOne: translate('Student Data Table - Info Completed One'),
    infoCompletedTextTwo: translate('Student Data Table - Info Completed Two'),
    infoCompletedTextThree: translate(
        'Student Data Table - Info Completed Three'
    ),
    standardProgressText: translate(
        'Student Data Table - Skill Quests - Progress through Standards'
    ),
    completedText: translate('Student Data Table - Completed')
});



// WEBPACK FOOTER //
// ./containers/skill-quests-mastery/student/components/student-data-table/student-data-translations.js